module.exports = __webpack_public_path__ + "img/NRaven64_ua.207789c9.webp";